// path: src/utils/authConfig.js
// Social login config. Replace Facebook placeholders before enabling FB login.

export const APPLE_AUTH = {
    // Native iOS Sign in with Apple tokens use the App ID (bundle ID) as `aud`.
    // Firebase Console → Authentication → Apple → Services ID must be this same
    // value for native login (not the web Services ID like *.signin).
    clientId: "com.courageouscorgis.memorymixup",
    redirectURI: "https://memory-mix-up.firebaseapp.com/__/auth/handler",
};

export const FACEBOOK_AUTH = {
    appId: "1679010640326514",
    clientToken: "20ca766f8f0c71df705665f516a32263",
    // public_profile only until Meta Use Case has email enabled for testing.
    // Add email in Meta → Use cases → Authentication → Permissions, then restore here.
    permissions: ["public_profile"],
};

export function isFacebookAuthConfigured() {
    const id = String(FACEBOOK_AUTH.appId || "").trim();
    return Boolean(id) && id !== "Replace later";
}
